// extracted by mini-css-extract-plugin
export default {"content_wrapper":"index-module__content_wrapper--PX4Vz"};